<template>
  <el-dialog
      :visible.sync="visible" 
      append-to-body
      @close="$emit('close')"
      width="550px" 
      class="acc_arrange"
      :close-on-click-modal="false"
      @open="handleOpen"
  >
      <template slot="title">
         <div class="acc_arrange__title">
            <div
              v-for = "i in tabList"
              :key = "i.id"
              @click="tab = i.id"
              class="title_tab"
              :class="{ 'active_tab': i.id === tab }"
            >
              {{ i.name }}
            </div>
         </div>
      </template>
			<div  v-loading='loading'>
        <!-- 整理凭证 -->
				<template v-if = "tab ===1">
            <div class="fliesUplaod">
              <span class="fliesUplaod_text">提示：若此月有凭证断号，整理后会将断号后的凭证依顺序前延，凭证顺序也会根据凭证号重新排序。</span>
              <el-form label-width="85px">
                <el-form-item label='整理范围：'>
                  <accounting-period @defaultTime="defaultTime" :isDaterange='false' superStyles='270px'></accounting-period>
                </el-form-item>
                <el-form-item label='凭证字：'>
                  <el-select size="mini" style="width: 270px;" v-model='form.fkVoucherWordId' clearable>
                    <el-option v-for='i in VoucherWord' :label="i.certificateWord" :value="i.id" :key='i.id'></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-radio v-model="form.mode" label="1">断号整理</el-radio>
                  <el-radio v-model="form.mode" label="2">按日期整理</el-radio>
                </el-form-item>
              </el-form>
            </div> 
          </template>
           <!-- 插入凭证 -->
          <template v-else>
            <el-form label-width="115px">
              <el-form-item label='范围：'>
                <accounting-period @defaultTime="getPeriod" :isDaterange='false' superStyles='270px'></accounting-period>
              </el-form-item>
              <el-form-item label='凭证字：'>
                  <el-select size="mini" style="width: 270px;" v-model='form1.certificateWordId' clearable>
                    <el-option v-for='i in VoucherWord' :label="i.certificateWord" :value="i.id" :key='i.id'></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label='将上述期间的：' >
                  <el-input size="small" placeholder="请输入" :class="{'errorTip' : textX}" style="width: 80px;" v-model="form1.x"></el-input>
                  <span> 号移动到：</span>
                  <el-input size="small" placeholder="请输入" :class="{'errorTip' : textY}" style="width: 80px;" v-model="form1.y"></el-input>
                  <span> 号之前</span><br>
                </el-form-item>
                <div style="color:#FF3049;margin-bottom: 30px;">
                  *原凭证号将改为新凭证号，之后凭证都将依次顺延一个凭证号
                </div>
            </el-form>
          </template>
          <div slot="footer" class="acc_arrange__footer">
            <el-button size="small"  @click="$emit('close')">取消</el-button>
            <el-button size="small" class='btn--confirm' @click="handleConfirm">确定</el-button>
          </div>
			</div>
		</el-dialog>
</template>
<script>
import accountingPeriod from '@/components/dialog/accountingPeriod'
export default {
  components: { accountingPeriod },
  props: {
    visible: Boolean,
    loading: Boolean,
    VoucherWord: Array
  },
  data() {
    return {
      tab: 1,
      tabList:[
        {
          name: "整理凭证",
          id: 1
        },
        {
          name: "插入凭证",
          id: 2
        }
      ],
      form1: {
        yearPeriod: "",
        certificateWordId: "",
        x: "",
        y: "",
      },
      form: {
        fkVoucherWordId: "",
        mode: "1"
      },
      textX: false,
      textY: false,
    }
  },
  watch: {
    VoucherWord(val) {
      if(val.length) {
        this.form.fkVoucherWordId = val[0].id
        this.form1.certificateWordId = val[0].id
      }
    }
  },
  methods: {
    handleOpen() {
      this.textX = false
      this.textY = false
    },
    handleConfirm() {
      // 限制正整数
      if(this.tab == 2) {
        const ref = /^[1-9]+[0-9]*$/
        this.textX = !ref.test(this.form1.x)
        this.textY = !ref.test(this.form1.y)
        if(!this.textX && !this.textY) {
          this.$emit('confirm',{ tab: this.tab,form: this.tab==1?this.form:this.form1 })
        }else {
          this.$message.error('请输入正整数')
        }
      }else {
        this.$emit('confirm',{ tab: this.tab,form: this.tab==1?this.form:this.form1 })
      }
    },
    getPeriod(data) {
      this.form1 = Object.assign(this.form1,{
				yearPeriod: this.$util.formatDate.format(data.yearPeriodsStart, 'yyyyMM'),
			});
    },
    // 接收会计期间数据
		defaultTime(data) {
			this.form = Object.assign(this.form,{
				yearPeriods: this.$util.formatDate.format(data.yearPeriodsStart, 'yyyyMM'),
			});
		},
  }
}
</script>
<style lang="less" scoped>
.acc_arrange {
  /deep/.el-form-item {
    margin-bottom: 15px
  }
  .fliesUplaod_text {
				color: #EC681D;
				display: inline-block;
				margin-bottom: 20px;
			}
  .active_tab {
    color: #269D7B;
  }
  .title_tab {
    margin-right: 30px;
    cursor: pointer;
  }
  &__footer {
    text-align: center;
  }
  &__title  {
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    display: flex;
    align-items: center;
  }
  .errorTip {
      /deep/.el-input__inner {
        border: 1px solid rgb(249, 79, 78) !important;
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/voucher/components/arrange.vue